// ===================================================
// 説明会日程の管理ファイル
// 日程を追加・変更する場合はここだけ編集してください
// ===================================================

export type ScheduleStatus = '受付中' | '残りわずか' | '満席';

export interface Schedule {
  date: string;       // 例: '3月21日（土）'
  time: string;       // 例: '17:00〜'
  format: string;     // 例: 'オンライン開催'
  status: ScheduleStatus;
}

export const schedules: Schedule[] = [
  {
    date: '4月1日（水）',
    time: '17:00〜',
    format: 'オンライン開催',
    status: '受付中',
  },
  {
    date: '4月4日（土）',
    time: '17:00〜',
    format: 'オンライン開催',
    status: '受付中',
  },
  // 新しい日程を追加する場合は↓のようにコピーして追記してください
  // {
  //   date: '4月○日（○）',
  //   time: '○○:○○〜',
  //   format: 'オンライン開催',
  //   status: '受付中',
  // },
];
